import { createContext, ReactNode, useContext } from 'react';
import { useSystemsState } from '../hooks/systems/useSystemsState';
import type { SystemSection } from '../hooks/systems/useSystemsState';

export type { SystemSection };
export type SystemsContextType = ReturnType<typeof useSystemsState>;

export const SystemsContext = createContext<SystemsContextType | null>(null);

export const SystemsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const systemsState = useSystemsState();

  return (
    <SystemsContext.Provider value={systemsState}>
      {children}
    </SystemsContext.Provider>
  );
};

export const useSystemsContext = (): SystemsContextType => {
  const context = useContext(SystemsContext);
  if (!context) {
    throw new Error('useSystemsContext must be used within a SystemsProvider');
  }
  return context;
};
